export function upsertCookie<TValue>(cookieName: string, cookieValue: TValue): void {
  // 1. Prepare the value (stringifying if it's an object/array)
  const stringValue = typeof cookieValue === "string" ? cookieValue : JSON.stringify(cookieValue);

  // 2. Define cookie attributes
  // Max-Age is set to 7 days (60s * 60m * 24h * 7d)
  const maxAge = 60 * 60 * 24 * 7;
  const path = "/";

  /**
   * 3. Construct the cookie string
   * - encodeURIComponent handles special characters in JSON
   * - SameSite=Lax is a modern security standard for CSRF protection
   */
  document.cookie = `${cookieName}=${encodeURIComponent(stringValue)}; Max-Age=${maxAge}; path=${path}; SameSite=Lax`;
}
